import { CreateGameScreen } from '@/screens/new-game'

export default function CreateGameRoute() {
  return <CreateGameScreen />
}
